export default __webpack_public_path__ + "static/media/SwingLegRecovery.eb45149e.png";